import { useMemo } from 'react';

type OnExpand = (name?: string) => void;

export type PanelProps = {
  name?: string;
  onExpand?: OnExpand;
  className: string;
  onToggle?: OnExpand;
  expanded: boolean;
};

export default (name?: string, onExpand?: OnExpand) => {
  const handleExpanding = useMemo(
    () => {
      if (name !== undefined && onExpand) {
        return (e, expanded: boolean) => {
          onExpand(expanded ? name : undefined);
        };
      }

      return;
    },
    [onExpand, name]
  );

  return {
    handleExpanding,
  };
};
